<template>
  <div class="order-main container" v-if="isShowProductInfo">
    <div class="form-item-title">
      询价商品清单
      <span style="margin-left: 20px; color: #f0250f">
        <!-- {{ routeData.includeFreight == 0 ? freightText : '' }} -->
      </span>
    </div>
    <div class="form-item-btn">
      <!-- && routeQueryType !== 'offer' -->
      <eui-btn v-if="isShowConsultRecord === 1" type="primary" @click="goUrl">
        磋商记录
      </eui-btn>
      <eui-btn
        v-if="routeQueryType == 'offer'"
        type="primary"
        @click="openPriceDialog"
      >
        批量报价
      </eui-btn>
    </div>
    <table-List
      style="margin-top: 10px"
      :loading="loading"
      :table-data="newTableData"
      :table-label="tableLabel"
      :index-show="true"
      :fixed-index="'left'"
      :max-height="'500'"
    >
      <!-- 交货期 -->
      <template #deliveryDate="slot">
        <el-input
          v-model="slot.scope.row.deliveryDate"
          v-if="routeQueryType == 'offer' && !consultationType"
          maxlength="12"
          min="0"
          oninput="value=value.replace(/[^0-9.]/g,'')"
          class="input-style"
          style="width: 100%"
        ></el-input>
        <div v-else>
          {{ slot.scope.row.deliveryDate }}
        </div>
      </template>
      <!-- 报价单价 -->
      <template #unitPrice="slot">
        <el-input
          v-if="routeQueryType == 'offer' && !consultationType"
          v-model.trim="slot.scope.row.price"
          maxlength="12"
          min="0"
          class="input-style"
          style="width: 100%"
          @change="calFee(slot.scope.row, 'price')"
        ></el-input>
        <div v-else>
          <div
            v-if="consultationType === 1 && routeQueryType == 'offer'"
            style="color: #f56c6c"
          >
            {{ slot.scope.row.supplierOfferDetailConsult.price }}
          </div>
          <div>
            <span v-if="consultationType === 1 && routeQueryType == 'offer'"
              >(原报价:</span
            >
            {{
              consultationType === 1 && routeQueryType == 'offer'
                ? `${slot.scope.row.price})`
                : slot.scope.row.price
            }}
          </div>
        </div>
      </template>

      <!-- 报价说明 -->
      <template #offerRemark="slot">
        <el-input
          v-if="routeQueryType == 'offer' && !consultationType"
          v-model="slot.scope.row.offerRemark"
          maxlength="100"
          min="0"
          class="input-style"
          style="width: 100%"
        ></el-input>
        <div v-else>
          {{ slot.scope.row.offerRemark }}
        </div>
      </template>
    </table-List>
    <div v-if="allPrice" class="total-money-box">
      报价总数量：
      <span class="total-money" style="margin-right: 10px">{{ allNum }} </span>
      报价总金额：
      <span class="total-money" :key="allPrice">{{ allPrice }} 元</span>
    </div>
    <batch-import
      :batch-import-visible.sync="batchImportVisible"
      :enquiry-id="$route.query.enquiryId"
      @getBatchImportList="getBatchImportList"
    />
  </div>
</template>

<script>
import tableList from '@/modules/projectA/components/common/e-table-list';
import BatchImport from '@/modules/projectA/pages/order/enquiryPrice/components/batchImport.vue';
import { calRoundNum } from '@/modules/projectA/utils/utils';
export default {
  components: {
    tableList,
    BatchImport,
  },
  props: {
    isShowProductInfo: {
      type: Boolean,
      default: true,
    },
    routeData: {
      type: Object,
      default: () => {},
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    isShowConsultRecord: {
      type: Number,
      default: 0,
    },
    routeQueryType: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    consultationType: {
      type: Number,
    },
  },
  computed: {
    allNum() {
      let totalNum = 0;
      this.newTableData.forEach((item) => {
        totalNum += Number(item.requiredQuantity);
      });
      return Number(totalNum).toFixed(3);
    },
    /* consultationType === 1 && routeQueryType == 'offer'" style="color: #f56c6c;">
              {{ slot.scope.row.supplierOfferDetailConsult.price  */
    allPrice() {
      let totalPrice = 0;
      // console.log('this.newTableData');
      this.newTableData.forEach((item) => {
        // console.log(item);
        if (this.consultationType === 1 && this.routeQueryType == 'offer') {
          if (item.supplierOfferDetailConsult.price) {
            totalPrice += Number(item.supplierOfferDetailConsult.totalPrice);
          }
        } else {
          if (item.price && item.totalPrice) {
            // console.log('item.totalPrice:', item.totalPrice);
            totalPrice += Number(item.totalPrice);
          }
        }
      });
      return totalPrice.toFixed(2);
    },
  },
  created() {
    this.newTableData = [...this.tableData];
  },
  data() {
    return {
      batchImportVisible: false,
      newTableData: [],
      tableLabel: [
        {
          label: '品名',
          param: 'productName',
          align: 'center',
          width: '180',
          fixed: 'left',
        },
        {
          label: '材质',
          param: 'material',
          align: 'center',
          // width: '180',
          // fixed: 'left',
        },
        {
          label: '规格型号',
          param: 'specifications',
          align: 'center',
          // width: '180',
        },
        //标准
        {
          label: '标准',
          param: 'standardType',
          align: 'center',
          // width: '180',
        },
        {
          label: '品牌',
          param: 'brandName',
          align: 'center',
          // width: '150',
        },

        // {
        //   label: '商品描述',
        //   param: 'productDescription',
        //   align: 'center',
        //   width: '150',
        // },
        {
          label: '物资类别',
          param: 'categoryName',
          align: 'center',
        },
        {
          label: '数量',
          param: 'requiredQuantity',
          align: 'center',
        },
        {
          label: '计量单位',
          param: 'unitName',
          align: 'center',
        },
        //交货期
        {
          label: '交货期（天）',
          param: 'deliveryDate',
          align: 'center',
          slot: 'deliveryDate',
        },
        //商品单价限额
        {
          label: '商品单价限额（元）',
          param: 'limitPrice',
          align: 'center',
        },
        //备注
        {
          label: '备注',
          param: 'remark',
          align: 'center',
        },
        {
          label: '单价（元）',
          param: 'price',
          align: 'center',
          slot: 'unitPrice',
          width: '150',
        },
        //金额（元）
        {
          label: '金额（元）',
          param: 'totalPrice',
          align: 'center',
          width: '150',
        },
        //报价说明
        {
          label: '报价说明',
          param: 'offerRemark',
          align: 'center',
          width: '150',
          slot: 'offerRemark',
        },
      ],
    };
  },
  methods: {
    getBatchImportList(data) {
      console.log(data, 'data');
      this.newTableData = this.newTableData.map((item) => {
        const obj = data.find(
          (item2) => item2.enquiryDetailId == item.enquiryDetailId
        );
        return {
          ...item,
          ...obj,
        };
      });
      data.forEach((item) => {
        console.log(item.price, 'item.price');

        if (item.price) {
          this.calFee(item, 'price');
        }
      });
      this.$emit('change', this.newTableData);
      // this.newTableData = [...data];
      // console.log(data, this.newTableData, "导入datadatadata");
    },
    goUrl() {
      const {
        supplierOfferId = '',
        enquiryId = '',
        createSource,
      } = this.$route.query;
      this.$router.push({
        path: '/negotiationRemark',
        query: {
          supplierOfferId,
          enquiryId,
          createSource,
        },
      });
    },
    openPriceDialog() {
      this.batchImportVisible = true;
    },
    // 计算
    calFee(data, flag) {
      const isPrice = Number(data.price);
      console.log(isPrice, 'data');
      if (isNaN(isPrice)) {
        this.$set(data, 'price', null);
        this.$set(data, 'totalPrice', null);
        return this.$message.warning('请输入正确报价单价！');
      }

      // 单价
      if (flag == 'price') {
        // 精确计算小计

        const totalPrice = calRoundNum(
          Number(data.price).toFixed(2),
          data.requiredQuantity
        );
        // 乘100获取精度
        const total = calRoundNum(totalPrice, 100);
        this.newTableData.map((item) => item);
        this.newTableData.forEach((item) => {
          if (item.enquiryDetailId == data.enquiryDetailId) {
            item.price = Number(data.price).toFixed(2);

            this.$set(
              item,
              'totalPrice',
              Number(Math.round(total) / 100).toFixed(2)
            );
          }
        });
      }
      this.newTableData = [...this.newTableData];
      this.$emit('change', this.newTableData);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-item-btn {
  margin-top: 10px;
}
.total-money-box {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0 0px;
  font-weight: bold;
}
.total-money {
  color: #f0250f;
  font-weight: bold;
}
</style>
